import apiClient from "config/apiClient";
import { DEFAULT_LIMIT_ITEMS } from "constants/data";
import insertObjectIf, { toSnakeCase } from "util/helper";
import { PaginationParamType } from "type";
import { CompanyType } from "../types/company";

export interface CompanyQuery extends PaginationParamType {
  id?: number;
  companyCd?: string;
  deleteFlag?: boolean;
  companyName?: string;
}

interface ResponseCompanyList {
  list: CompanyType[];
  total: number;
}

/**
 *  get company list
 * @param body CompanyQuery
 */
export default async function getCompanyListApi(body?: CompanyQuery): Promise<ResponseCompanyList> {
  const res = await apiClient.post<ResponseCompanyList>(
    `/mst/company/select`,
    toSnakeCase({
      limit: body?.limit || DEFAULT_LIMIT_ITEMS,
      offset: body?.offset || 1,
      ...insertObjectIf(body?.companyCd, { companyCd: body?.companyCd }),
      ...insertObjectIf(body?.companyName, { companyName: body?.companyName }),
    }),
  );
  return { list: res.data?.list || [], total: res.data?.total || 0 };
}
